// removed by extract-text-webpack-plugin
module.exports = {"block":"PlayButton_block_2WwYB","icon":"PlayButton_icon_94_gK"};